import * as React from "react";
const SvgLibrary = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 16 12"
    {...props}
  >
    <path
      fill="#091E42"
      d="M4.333 8.666q.783 0 1.525.175a7.3 7.3 0 0 1 1.475.525V2.799a5.7 5.7 0 0 0-1.45-.6 6.1 6.1 0 0 0-2.741-.083A5.8 5.8 0 0 0 2 2.466v6.6a7.6 7.6 0 0 1 1.158-.3q.575-.1 1.175-.1m4.333.7a7.3 7.3 0 0 1 1.476-.525 6.845 6.845 0 0 1 2.7-.075q.575.1 1.158.3v-6.6a5.8 5.8 0 0 0-1.142-.35 6.15 6.15 0 0 0-2.742.083 5.7 5.7 0 0 0-1.45.6zM8 11.333a6.4 6.4 0 0 0-1.734-.984A5.5 5.5 0 0 0 4.334 10q-.7 0-1.375.184-.675.183-1.291.516a.64.64 0 0 1-.675-.016.64.64 0 0 1-.325-.584V2.066q0-.183.091-.35a.57.57 0 0 1 .275-.25 7 7 0 0 1 1.6-.6 7.3 7.3 0 0 1 1.7-.2q.967 0 1.892.25A7.2 7.2 0 0 1 8 1.666a7.2 7.2 0 0 1 3.666-1q.867 0 1.7.2a7 7 0 0 1 1.6.6.57.57 0 0 1 .276.25.7.7 0 0 1 .091.35v8.033q0 .383-.325.584a.64.64 0 0 1-.675.016 6 6 0 0 0-1.292-.516 5.2 5.2 0 0 0-1.375-.184q-.999 0-1.933.35Q8.8 10.7 8 11.333"
    />
  </svg>
);
export default SvgLibrary;
